import { render, staticRenderFns } from "./TCenter.vue?vue&type=template&id=11124253"
import script from "./TCenter.vue?vue&type=script&lang=js"
export * from "./TCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports